// import Vue from 'vue'
import Clipboard from 'clipboard'

function clipboardSuccess () {
  alert("复制成功!");
}

function clipboardError () {
  alert("失败！！！");
}

export function handleClipboard (text, event, onSuccess, onError) {
  try {
    // 参数验证
    if (typeof text !== 'string') {
      console.error('handleClipboard: text must be a string');
      onError && onError();
      return;
    }

    // 创建一个临时的按钮元素作为复制目标
    const button = document.createElement('button');
    button.style.position = 'fixed';
    button.style.left = '-9999px';
    button.style.top = '0';
    document.body.appendChild(button);

    const clipboard = new Clipboard(button, {
      text: () => text
    });

    clipboard.on('success', () => {
      onSuccess ? onSuccess() : clipboardSuccess();
      clipboard.off('error');
      clipboard.off('success');
      clipboard.destroy();
      document.body.removeChild(button);
    });

    clipboard.on('error', () => {
      onError ? onError() : clipboardError();
      clipboard.off('error');
      clipboard.off('success');
      clipboard.destroy();
      document.body.removeChild(button);
    });

    // 模拟点击事件
    button.click();
  } catch (error) {
    console.error('handleClipboard error:', error);
    onError && onError();
  }
}
